export default __webpack_public_path__ + "static/media/property_1_2.04b9e840.webp";